import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

type Props = {
    children: React.ReactNode;
    hostname: string;
    clientId?: string;
    domain?: string;
};

const isLocalBypassDomain = (hostname: string): boolean => {
    return /^m-local/i.test(hostname);
};

export const CustomAuth0Provider: React.FC<Props> = ({ children, hostname, clientId, domain }) => {
    if (isLocalBypassDomain(hostname)) {
        console.log('Bypassing Auth0 for local development');
        return <>{children}</>;
    }

    return (
        <Auth0Provider domain={domain} clientId={clientId}>
            {children}
        </Auth0Provider>
    );
};
